/**
 * 測定結果管理ページ用のスクリプト
 */
 if (is_route('measurement.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        measurement_event_set();
        measurement_detail_event_set();
        measurement_setting_event_set();
        measurement_reassign_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.measurement_event_set = function() {

    /*---- 検索モード切り替え時 ----*/

    // 一覧検索ボタンクリック時
    $(document).on('click', '#mode-latest-button', function() {
        // 表示モード設定
        $('input[name="mode"]').val('latest');
        // ボタン表示制御
        $(this).removeClass('button-inactive');
        $(this).addClass('button-active');
        $('#mode-detail-button').removeClass('button-active');
        $('#mode-detail-button').addClass('button-inactive');
        $('#mode-unmeasured-button').removeClass('button-active');
        $('#mode-unmeasured-button').addClass('button-inactive');
        $('#search-form-action_print').removeClass('display-none');
        $('#search-form-action_reassign').removeClass('display-none');
        // $('.search-note').addClass('display-none');
        // 検索実行
        search(true);
    });
    // 詳細検索ボタンクリック時
    $(document).on('click', '#mode-detail-button', function() {
        // 表示モード設定
        $('input[name="mode"]').val('detail');
        // ボタン表示制御
        $(this).removeClass('button-inactive');
        $(this).addClass('button-active');
        $('#mode-latest-button').removeClass('button-active');
        $('#mode-latest-button').addClass('button-inactive');
        $('#mode-unmeasured-button').removeClass('button-active');
        $('#mode-unmeasured-button').addClass('button-inactive');
        $('#search-form-action_print').addClass('display-none');
        $('#search-form-action_reassign').addClass('display-none');
        // $('.search-note').removeClass('display-none');
        // // 測定日時を7日の範囲に設定する
        // $('#measurement-search-form-started_at').trigger('change');
        // 検索実行
        search(true);
    });
    // 当日未測定者検索ボタンクリック時
    $(document).on('click', '#mode-unmeasured-button', function() {
        // 表示モード設定
        $('input[name="mode"]').val('unmeasured');
        // ボタン表示制御
        $(this).removeClass('button-inactive');
        $(this).addClass('button-active');
        $('#mode-latest-button').removeClass('button-active');
        $('#mode-latest-button').addClass('button-inactive');
        $('#mode-detail-button').removeClass('button-active');
        $('#mode-detail-button').addClass('button-inactive');
        $('#search-form-action_print').addClass('display-none');
        $('#search-form-action_reassign').addClass('display-none');
        // 検索実行
        search(true);
    });

    /*---- 検索条件変更時 ----*/

    // 測定日時（開始）変更時
    $(document).on('change', '#measurement-search-form-started_at', function () {
        changeStartedAt(this, '#measurement-search-form-ended_at', getRangeDays());
    });
    $(document).on('change', '#measurement-reassign-modal-started_at', function () {
        changeStartedAt(this, '#measurement-reassign-modal-ended_at', getRangeDays());
    });

    // 測定日時（終了）変更時
    $(document).on('change', '#measurement-search-form-ended_at', function () {
        changeEndedAt(this, '#measurement-search-form-started_at', getRangeDays());
    });
    $(document).on('change', '#measurement-reassign-modal-ended_at', function () {
        changeEndedAt(this, '#measurement-reassign-modal-started_at', getRangeDays());
    });

    /**
     * 指定可能な日付範囲を返却する
     * @param {*} mode
     * @returns
     */
    function getRangeDays()
    {
        if($('input[name="mode"]').val() == 'detail'){
            return 7;
        }else{
            return 31;
        }
    }

    /**
     * 指定可能な測定日時（開始）を設定する
     * @param {*} elm
     * @param {*} target
     * @param {*} days
     */
    function changeStartedAt(elm, target, days)
    {
        let last_day = null;
        selected_date = $(elm).val();
        set_end = $(target).val();
        if(set_end != ''){
            selected_date = new Date(selected_date);
            chk_date_over = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + days);
            chk_date = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate());
            set_end = new Date(set_end);
            yyyymmdd = new Date(set_end.getFullYear(),set_end.getMonth(),set_end.getDate());
            if(chk_date_over.getTime() < yyyymmdd.getTime()){
                yyyymmdd = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + days);
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0"+( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd.getDate() ).slice(-2);
                $(target).val(last_day);
            }else if(chk_date.getTime() > yyyymmdd.getTime()){
                last_day = chk_date.getFullYear()+'/'+
                        ( "0"+( chk_date.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+chk_date.getDate() ).slice(-2);
                $(target).val(last_day);
            }
        }
    }

    /**
     * 指定可能な測定日時（終了）を設定する
     * @param {*} elm
     * @param {*} target
     * @param {*} days
     */
    function changeEndedAt(elm, target, days)
    {
        let last_day = null;
        selected_date = $(elm).val();
        set_start = $(target).val();
        if(set_start != ''){
            selected_date = new Date(selected_date);
            set_start = new Date(set_start);
            yyyymmdd = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate() + days);
            yyyymmdd_2 = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate());
            if(selected_date.getTime() > yyyymmdd.getTime()){
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0"+( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd.getDate() ).slice(-2);
                $(elm).val(last_day);
            }else if(selected_date.getTime() < yyyymmdd_2.getTime()){
                last_day = yyyymmdd_2.getFullYear()+'/'+
                        ( "0"+( yyyymmdd_2.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd_2.getDate() ).slice(-2);
                $(elm).val(last_day);
            }
        }
    }

    // 会社変更時
    $(document).on('change', '.search-form-company-select', function() {
        if ($(this).attr('id') == 'template-list-modal-company_id' || $(this).attr('id') == 'reminder-setting-modal-company_id') {
            return;
        }
        _select.set_select(this, 'select.search-form-section-select', {'company_id': $(this).val()}, function() {
            $('select.search-form-user-select').val(null).trigger('change');
        });
    });

    /*---- 営業所変更時 ----*/
    $(document).on('change', '.search-form-section-select', function() {
        if ($(this).attr('id') == 'template-list-modal-section_id' || $(this).attr('id') == 'reminder-setting-modal-section_id') {
            return;
        }
        companyId = $('.search-form-company-select').val();
        sectionId = $(this).val();
        _select.set_select(this, 'select.search-form-user-select', sectionId ? {'section_id': sectionId} : {'company_id': companyId}, function() {
            $('select.search-form-user-select').val(null).trigger('change');
        });
    });

    /*---- 検索方法切り替え時 ----*/

    $(document).off('change', '.search-form-search_mode');
    $(document).on('change', '.search-form-search_mode', function() {
        if($(this).val() == 'text'){
            $('.search_mode_text').removeClass('display-none');
            $('.search_mode_pulldown').addClass('display-none');
            $('select.search-form-user-select').val(null).trigger('change');
        }else if($(this).val() == 'pulldown'){
            $('.search_mode_text').addClass('display-none');
            $('.search_mode_pulldown').removeClass('display-none');
            $('.search_mode_text').children().val('');
        }
    });

    /*---- 写真表示時 ----*/

    // 写真表示時
    $(document).on('click', '#measurementlist td', function () {
        let selecterId = $(this).attr('id');
        if(selecterId == 'td-alc_photo_path'){
            window.open($(this).data('url'), '_blank');
            return false;
        }
    });

    /*---- 履歴表示時 ----*/

    // 詳細表示時
    $(document).on('click', '#measurementlatestlist td', function () {
        let selecterId = $(this).attr('id');
        let className = $(this).attr('class');
        if(selecterId == 'td-alc_photo_path1' || selecterId == 'td-alc_photo_path2'){
            window.open($(this).data('url'), '_blank');
            return false;
        }
        if(selecterId == 'td-confirmed_user_name1' || className == 'td-confirmed_user_name1-check'
            || selecterId == 'td-confirmed_user_name2' || className == 'td-confirmed_user_name2-check'){
            return false;
        }
        _modal.create($(this).parent("tr"), 'detail-modal', ['id', 'started_at', 'ended_at']);
        return false;
    });

    /*---- 確認時 ----*/

    // 確認時
    $(document).on('click', '.measurement-confirm', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 運転前or運転後の取得
        let target = $(this).data('target');
        // 対象ID取得
        let id = $(this).data('id');
        let holding_id = $(this).data('holding_id');
        let company_id = $(this).data('company_id');
        let section_id = $(this).data('section_id');
        let started_at = $(this).data('started_at');
        let ended_at = $(this).data('ended_at');
        // 表示制御するコントロールを取得
        let btnConfirm = $(this);
        let btnCancel = $('#measurement-confirm-cancel-btn_'+id);
        let userNameArea = $('#confirmed_user_name_'+id);
        let chk = $('#measurement-confirm-check_'+id);
        _ajax.post(action, { 'id': id, 'holding_id': holding_id, 'company_id': company_id, 'section_id': section_id, 'started_at': started_at, 'ended_at': ended_at }, function (response) {
            $(btnConfirm).addClass('display-none');
            $(btnCancel).removeClass('display-none');
            if(response.isShowConfirmedTime){
                $(userNameArea).html('<span>'+response.user_name+'<br>'+response.confirmed_time+'</span>');
            }else{
                $(userNameArea).html('<span>'+response.user_name+'</span>');
            }
            $(userNameArea).removeClass('display-none');
            $(chk).remove();
            // 一覧のチェック状態を判定し確認ボタンを有効化
            $('#measurement-multi-confirm-'+target+'-button').prop('disabled', ($('.measurement-confirm-'+target+'-check:checked').length == 0));
            // 完了メッセージをセットする
            _complete.set(response);
        }, function(xhr, status, errorThrown){
            // Jsonのパースが行われていない場合はTextを元にパースする
            if (xhr.responseJSON === null) {
                xhr.responseJSON = JSON.parse(xhr.responseText);
            }
            if(xhr.responseJSON.code == 'not_found'){
                toastr.warning(xhr.responseJSON.subject);
            }else{
                _error.omitted(xhr, status, errorThrown);
            }
        });
        return false;
    });

    // 確認取消時
    $(document).on('click', '.measurement-confirm-cancel', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 運転前or運転後の取得
        let target = $(this).data('target');
        // 対象ID取得
        let id = $(this).data('id');
        let holding_id = $(this).data('holding_id');
        let company_id = $(this).data('company_id');
        let section_id = $(this).data('section_id');
        let started_at = $(this).data('started_at');
        let ended_at = $(this).data('ended_at');
        // 表示制御するコントロールを取得
        let btnConfirm = $('#measurement-confirm-btn_'+id);
        let btnCancel = $(this);
        let userNameArea = $('#confirmed_user_name_'+id);
        let tdChk = $('#td-confirmed_user_name-check_'+id);
        _ajax.post(action, {'id': id, 'holding_id': holding_id, 'company_id': company_id, 'section_id': section_id, 'started_at': started_at, 'ended_at': ended_at, 'target': target}, function (response) {
            $(btnConfirm).removeClass('display-none');
            $(btnCancel).addClass('display-none');
            $(userNameArea).empty();
            $(userNameArea).addClass('display-none');
            $(tdChk).html(response.confirm_checkbox);
            // 一覧のチェック状態を判定し確認ボタンを有効化
            $('#measurement-multi-confirm-'+target+'-button').prop('disabled', ($('.measurement-confirm-'+target+'-check:checked').length == 0));
            // 完了メッセージをセットする
            _complete.set(response);
        }, function(xhr, status, errorThrown){
            // Jsonのパースが行われていない場合はTextを元にパースする
            if (xhr.responseJSON === null) {
                xhr.responseJSON = JSON.parse(xhr.responseText);
            }
            if(xhr.responseJSON.code == 'not_found'){
                toastr.warning(xhr.responseJSON.subject);
            }else{
                _error.omitted(xhr, status, errorThrown);
            }
        });
    });

    /*---- 一括確認チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#measurement-all-confirm-before', function () {
        $(".measurement-confirm-before-check").prop('checked', $(this).prop('checked'));
    });
    $(document).on('click', '#measurement-all-confirm-after', function () {
        $(".measurement-confirm-after-check").prop('checked', $(this).prop('checked'));
    });
    $(document).on('click', '#measurement-all-confirm', function () {
        $(".measurement-confirm-check").prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.measurement-confirm-before-check, .measurement-confirm-after-check, .measurement-confirm-check', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });
    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#measurement-all-confirm-before, .measurement-confirm-before-check', function () {
        // 一覧のチェック状態を判定し確認ボタンを有効化
        $('#measurement-multi-confirm-before-button').prop('disabled', ($('.measurement-confirm-before-check:checked').length == 0));
    });
    $(document).on('change', '#measurement-all-confirm-after, .measurement-confirm-after-check', function () {
        // 一覧のチェック状態を判定し確認ボタンを有効化
        $('#measurement-multi-confirm-after-button').prop('disabled', ($('.measurement-confirm-after-check:checked').length == 0));
    });
    $(document).on('change', '#measurement-all-confirm, .measurement-confirm-check', function () {
        // 一覧のチェック状態を判定し確認ボタンを有効化
        $('#measurement-multi-confirm-button').prop('disabled', ($('.measurement-confirm-check:checked').length == 0));
    });

    /*---- 一括確認クリック時 ----*/

    // 一括確認クリック時
    $(document).on('click', '#measurement-multi-confirm-before-button, #measurement-multi-confirm-after-button, #measurement-multi-confirm-button', function () {
        var target = $(this).data('target');
        var ids = [];
        var alcTimes = [];
        if(target == "before"){
            $('.measurement-confirm-before-check[name="ids_before[]"]:checked').map(function() {
                ids.push($(this).val());
            });
        }else if(target == "after"){
            $('.measurement-confirm-after-check[name="ids_after[]"]:checked').map(function() {
                ids.push($(this).val());
            });
        }else{
            $('.measurement-confirm-check[name="ids_[]"]:checked').map(function() {
                ids.push($(this).val());
            });
        }
        // 検索条件を取得
        let datas = getConditions(false);
        datas.push({ 'name' : 'target', 'value' : target});
        datas.push({ 'name' : 'ids', 'value' : ids});
        _modal.create_with_data(this, 'confirm-modal', datas);
    });

    /*---- 一括確認処理 ----*/

    // 一括確認実行時
    $(document).on('click', '[data-multi-confirm-modal]', function () {
        _modal.submit(this, 'multi-confirm-modal', function(results) {
            _modal.hide('#measurement-confirm-modal');
            $("#measurement-all-confirm-before, #measurement-all-confirm-after, #measurement-all-confirm").trigger('change');
        }, null, '-form', true);
    });

    // 検索フォームの変更時
    $(document).on('change', '#toolbar-keyword-search', function() {
        search();
    });
    // キーワード検索の実行ボタンクリック時
    $(document).on('click', '#toolbar-keyword-search-submit, #toolbar-keyword-search-reset', function() {
        search();
    });

    /*---- 検索 ----*/

    // ワンボタン抽出押下時
    $(document).on('change', '[name="search_type"], [name="unmeasured_type"]', function () {
        search();
    });

    // 検索ボタン押下時
    $(document).on('click', '#search-form-action_search', function () {
        $(this).prop('disabled', true);
        search();
    });

    /**
     * 検索処理
     * @param {*} conditions
     * @param {*} isClear 
     * @returns 
     */
    function search(isClear=false)
    {
        let datas = getConditions(isClear);
        let excutionData = [];
        excutionData.push('holding_id', 'company_id', 'section_id', 'page', 'mode');
        var action = $('#measurement-search-form').attr('action').replace('/list', '');
        action = _request.create_affiliation_url(action, true, datas, excutionData);
        location.href = action;
        return false;
    }

    /**
     * 検索条件を返却
     * @param {*} isClear
     * @returns
     */
    function getConditions(isClear)
    {
        let datas = $('#measurement-search-form').serializeArray();
        datas.push({ 'name' : 'is_clear', 'value' : isClear});
        datas.push({ 'name' : 'keyword', 'value' : $('#toolbar-keyword-search').val()});
        return datas;
    }

    /*---- 印刷ボタン押下時 ----*/

    // 印刷時
    $(document).on('click', '#search-form-action_print', function () {
        // 送信値を配列化
        let datas = $('#measurement-search-form').serializeArray();
        let action = extend_url_query($(this).data('action'));
        // BlobでPDFを別ウィンドウで表示
        _ajax.blob(action, datas, function (blob) {
            window.open(window.URL.createObjectURL(blob), '_blank');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- CSVダウンロード時 ----*/

    // // CSVダウンロード時
    // $(document).on('click', '#search-form-action_download', function () {
    //     // アクションの取得
    //     let action = extend_url_query($(this).data('action'));
    //     // 検索フォームを配列化
    //     let datas = $('#measurement-search-form').serializeArray();
    //     // ポスト送信を実行
    //     post(action, datas);
    // });

    $('.hover_img').on({
        'mouseenter': function() {
            $('img', this).fadeOut(100);
        },
        'mouseleave': function() {
            $('img', this).fadeIn(100);
        }
    });

    /*---- 編集時 ----*/

    // 編集ボタン押下時：測定結果一覧を表示する
    $(document).on('click', '[data-reassign-modal]', function () {
        let holding_id = $('#measurement-search-form-holding_id').val();
        let company_id = $('#measurement-search-form-company_id').val();
        let section_id = $(this).data('section_id');
        let started_at = $('#measurement-search-form-started_at').val();
        let ended_at = $('#measurement-search-form-ended_at').val();
        _modal.create_with_data(this, 'reassign-modal', {'holding_id': holding_id, 'company_id': company_id, 'section_id': section_id, 'started_at': started_at, 'ended_at': ended_at});
    });

    // 初期表示時に選択状態とする
    $("#measurement-all-confirm-before, #measurement-all-confirm-after").trigger('change');

    /*---- 未測定者検索 ----*/

    // テンプレート一覧表示時
    $(document).on('click', '[data-template-list-modal]', function () {
        _modal.create(this, 'template-list-modal', ['holding_id', 'company_id', 'section_id']);
    });

    // テンプレート一覧内の会社 or 営業所変更時
    $(document).on('select2:selecting', '#template-list-modal-company_id:enabled, #template-list-modal-section_id', function() {
        if ($(this).attr('id') == 'template-list-modal-company_id') {
            $('#template-list-modal-section_id').val('');
        }
        const form = $(this).parents('form');
        _modal.update(form.data('modal_id'), form.attr('action'), form.serializeArray());
    });

    // テンプレート設定画面表示
    $(document).on('click', '[data-template-setting-modal]', function () {
        _modal.create(this, 'template-setting-modal', ['id']);
    });

    // テンプレート保存時
    $(document).on('click', '[data-template-save-modal]', function () {
        _ajax.submit('#template-setting-modal-form', function(results){
            _modal.hide('#template-setting-modal');
            _modal.create('[data-template-list-modal]', 'template-list-modal', ['holding_id', 'company_id', 'section_id']);
            // 完了メッセージをセットする
            _complete.set(results);
        }, function(xhr, status, errorThrown){
            _error.set('#template-setting-modal', xhr, status, errorThrown, false);
        });
    });

    // テンプレート削除確認時
    $(document).on('click', '[data-template-confirm-modal]', function () {
        _modal.create(this, 'template-confirm-modal', ['id']);
    });

    // テンプレート削除実行時
    $(document).on('click', '[data-template-delete-modal]', function () {
        _ajax.submit('#template-delete-modal-form', function(results){
            _modal.hide('#template-confirm-modal');
            _modal.create('[data-template-list-modal]', 'template-list-modal', ['holding_id', 'company_id', 'section_id']);
            // 完了メッセージをセットする
            _complete.set(results);
        });
    });

    /*---- メール一括送信チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#user-all-reminder-checkbox', function () {
        $(".user-reminder-checkbox").prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.user-reminder-checkbox', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });

    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#user-all-reminder-checkbox, .user-reminder-checkbox', function () {
        // 一覧のチェック状態を判定しメール送信ボタンを有効化
        $('#user-multi-reminder-setting-button').prop('disabled', ($('.user-reminder-checkbox:checked').length == 0));
    });

    // メール送信モーダル表示時
    $(document).on('click', '[data-reminder-setting-modal]', function () {
        const userIds = [];
        $('.user-reminder-checkbox[name="user_ids[]"]:checked').map(function() {
            userIds.push($(this).val());
        });
        if (userIds.length > 0) {
            _modal.create_with_data(this, 'reminder-setting-modal', {'user_ids': userIds, 'holding_id' : $(this).data('holding_id'), 'company_id' : $(this).data('company_id')});
        }
    });

    // メール送信モーダル内の会社 or 営業所変更時
    $(document).on('select2:selecting', '#reminder-setting-modal-company_id:enabled, #reminder-setting-modal-section_id', function() {
        if ($(this).attr('id') == 'reminder-setting-modal-company_id') {
            $('#reminder-setting-modal-section_id').val('');
        }
        const form = $(this).parents('form');
        _modal.update(form.data('modal_id'), form.attr('action'), form.serializeArray());
    });

    // メール送信モーダルのテンプレート反映ボタン押下時
    $(document).on('click', '.template-reflect-btn', function () {
        $('#reminder-setting-modal-message_title').val($(this).data('message-title'));
        $('#reminder-setting-modal-message_body').val($(this).data('message-body'));
    });

    // メール送信時
    $(document).on('click', '[data-reminder-send-modal]', function () {
        const action = $(this).data('action');
        let datas = $('#reminder-setting-modal-form').serializeArray();
        // テンプレート検索用のcompany_idとsection_idを除外
        const removeNames = ['company_id', 'section_id'];
        datas = datas.filter(function (item) {
            return !removeNames.includes(item.name);
        });
        _ajax.post(action, datas, function (result) {
            // 完了メッセージをセットする
            _complete.set(result);
            _modal.hide('#reminder-setting-modal');
        }, function(xhr, status, errorThrown){
            _error.set('#reminder-setting-modal', xhr, status, errorThrown, false);
        });
    });
}

/**
 * 測定結果詳細モーダル表示時のイベント設定
 */
 window.measurement_detail_event_set = function() {

    // /*---- 設定表示時 ----*/

    // // 設定表示時
    // $(document).on('click', '#measurement-detail-modal [data-setting-modal]', function () {
    //     _modal.create(this, 'setting-modal', ['id', 'latest_id'], false, function(){
    //         $('select.section-select').trigger('change');
    //         $('#measurement-setting-modal-alc_input_type').trigger('change');
    //     });
    // });

    // /*---- 設定保存時 ----*/

    // // 設定保存時
    // $(document).on('click', '#measurement-detail-modal [data-save-modal]', function () {
    //     _modal.submit(this, 'save-modal', function(results) {
    //         $('[data-detail-modal=measurement-detail-modal][data-id=' + results.measurement.id + ']').trigger('click');
    //     }, function() {
    //     });
    // });

    // /*---- 削除確認時 ----*/

    // // 削除確認時
    // $(document).on('click', '#measurement-detail-modal-delete', function () {
    //     var ids = ($(this).data('id') == null ? [] : [$(this).data('id')]);
    //     // if ($(this).data('id') == null) {
    //     //     $('.measurement-delete[name="ids[]"]:checked').map(function() {
    //     //         ids.push($(this).val());
    //     //     });
    //     // }
    //     if (ids.length > 0) {
    //         _modal.create_with_data(this, 'confirm-modal', {'ids': ids});
    //     }
    // });

    // /*---- 削除処理 ----*/

    // // 削除実行時
    // $(document).on('click', '[data-delete-modal]', function () {
    //     _modal.submit(this, 'delete-modal', function(results) {
    //         _modal.hide('#measurement-detail-modal');
    //     });
    // });

}

/**
 * 設定モーダル表示時のイベント設定
 */
 window.measurement_setting_event_set = function() {

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '#measurement-setting-modal [data-save-modal]', function () {
        measurement_modal_submit(this, 'save-modal', function(){
            // 測定結果編集モーダルを更新する
            $('#measurement-reassign-modal-started_at').trigger('change');
        });
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '#measurement-setting-modal-delete', function () {
        measurement_delete_confirm(this);
    });

    /*---- 削除処理 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        measurement_modal_submit(this, 'delete-modal', function(){
            // モーダルを閉じる
            _modal.hide('#measurement-setting-modal');
            // 測定結果編集モーダルを更新する
            $('#measurement-reassign-modal-started_at').trigger('change');
        });
    });

    /*---- 入力方法変更時 ----*/
    $(document).on('change', '#measurement-setting-modal-alc_input_type', function () {
        let alcInputType = $(this).val();
        if(alcInputType == 2){
            $('#form-alc_value').toggleClass('display-none', false);
            $('#form-alc_result_check').toggleClass('display-none', true);
            // $('#measurement-setting-modal-alc_value').prop('disabled', false);
            // $('#measurement-setting-modal-alc_result_check').prop('disabled', true);
        }else if(alcInputType == 3){
            $('#form-alc_value').toggleClass('display-none', true);
            $('#form-alc_result_check').toggleClass('display-none', false);
            // $('#measurement-setting-modal-alc_value').prop('disabled', true);
            // $('#measurement-setting-modal-alc_result_check').prop('disabled', false);
        }else{
            $('#form-alc_value').toggleClass('display-none', false);
            $('#form-alc_result_check').toggleClass('display-none', true);
            // $('#measurement-setting-modal-alc_value').prop('disabled', true);
            // $('#measurement-setting-modal-alc_result_check').prop('disabled', true);
        }
    });

}

/**
 * 測定結果一覧（編集用）モーダル表示時のイベント設定
 */
 window.measurement_reassign_event_set = function() {

    /*---- 初期表示時 ----*/

    // 営業所に所属する乗務員を表示
    // _select.set_select($('.driver-select'), 'select.driver-select', {'section_id': $('#measurement-reassign-modal-section_id').val(), 'type': 'driver'});

    /*---- 検索時 ----*/
    $(document).on('change', '#measurement-reassign-modal-section_id, #measurement-reassign-modal-driver_id, #measurement-reassign-modal-started_at, #measurement-reassign-modal-ended_at', function() {
        let form = $(this).parents('form');
        let datas = $(form).serializeArray();
        let action = $(form).attr('action');
        let modalId = $(form).data('modal_id');
        _modal.update(modalId, action, datas, null, function () {
            const today = $('#measurement-reassign-modal-started_at').data('today');
            $('#measurement-reassign-modal-started_at').val(today);
            $('#measurement-reassign-modal-ended_at').val(today);
            $('#measurement-reassign-modal-started_at').trigger('change');
        });
    });

    /*---- 設定表示時 ----*/

    // 追加・編集ボタン押下時
    $(document).on('click', '#measurement-reassign-modal [data-setting-modal]', function () {
        let datas = getPostData();
        if($(this).data('id') != null){
            datas['id'] = $(this).data('id');
        }
        if($(this).data('latest_id') != null){
            datas['latest_id'] = $(this).data('latest_id');
        }
        if($(this).data('session_serial') != null){
            datas['session_serial'] = $(this).data('session_serial');
        }
        _modal.create_with_data(this, 'setting-modal', datas, false, function(){
            $('select.section-select').trigger('change');
            $('select.vehicle-section-select').trigger('change');
            $('#measurement-setting-modal-alc_input_type').trigger('change');
        });
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '#measurement-reassign-modal-delete', function () {
        measurement_delete_confirm(this);
    });

    /*---- 復元時 ----*/

    // 復元時
    $(document).on('click', '#measurement-reassign-modal-restore', function () {
        let ids = ($(this).data('id') == null ? [] : [$(this).data('id')]);
        let type = $(this).data('type');
        if (ids.length > 0) {
            restore(ids, type, $(this).data('action'), function(){
                // 再検索する
                $('#measurement-reassign-modal-ended_at').trigger('change');
            });
        }
    });

    /*---- 反映確認時 ----*/

    // 反映ボタン押下時
    $(document).on('click', '#measurement-reassign-modal-reassign', function () {
        let datas = getPostData();
        let ids = [];
        $('[name="reassign_ids[]"]').map(function() {
            ids.push($(this).val());
        });
        if(ids.length > 0){
            datas['ids'] = ids;
        }
        _modal.create_with_data(this, 'confirm-modal', datas, false, null, 'action', true);
    });

    /*---- 反映実行時 ----*/

    // 実行ボタン押下時
    $(document).on('click', '[data-reassign-confirm-modal]', function () {
        var modalId = create_id($(this).data('reassign-confirm-modal'));
        var formId = modalId + '-form';
        // 送信前にエラーをリセット
        _error.reset()
        $('#processing-message').html("");
        // post送信
        _ajax.submit(formId, function (results) {
            $('#measurement-reassign-modal-not_reflected_count').val(0);
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide(modalId);
            // 測定結果編集を閉じる
            _modal.hide('#measurement-reassign-modal');
            // コンテンツを読込
            load_contents(null, false, '#measurement-search-form');
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.set(modalId, xhr, status, errorThrown);
            // 対象データに対して他の処理が実行中の場合はメッセージ表示
            if (xhr.responseJSON.code == 'processing') {
                $('#processing-message').html(xhr.responseJSON.subject);
            }
        });
    });

    function getPostData()
    {
        return {
            'holding_id' :$('#measurement-reassign-modal-holding_id').val(),
            'company_id' :$('#measurement-reassign-modal-company_id').val(),
            'section_id' :$('#measurement-reassign-modal-section_id').val(),
            'driver_id' :$('#measurement-reassign-modal-driver_id').val(),
            'started_at' :$('#measurement-reassign-modal-started_at').val(),
            'ended_at' :$('#measurement-reassign-modal-ended_at').val(),
            'type' : 'reassign',
        };
    }

    /*---- モーダル非表示時 ----*/

    $(document).on('hide.bs.modal', '#measurement-reassign-modal', function () {
        if($('#measurement-reassign-modal-not_reflected_count').val() > 0){
            if (confirm('反映されていない測定結果が存在します。よろしいですか？')){
                let action = $('#measurement-reassign-modal-form').data('cancel_action');
                _ajax.post(action, [],  function (response) {
                    // 完了メッセージをセットする
                    _complete.set(response);
                }, function(xhr, status, errorThrown){
                    _error.omitted(xhr, status, errorThrown);
                });
            }else{
                return false;
            }
        }
    });

    /**
     * 復元処理
     *
     */
     function restore(ids, type, action, callback = null)
     {
         let holding_id = $('#measurement-reassign-modal-holding_id').val();
         let company_id = $('#measurement-reassign-modal-company_id').val();
         _ajax.post(action, {'ids': ids, 'type': type, 'holding_id': holding_id, 'company_id': company_id}, function (response) {
             // 完了メッセージをセットする
             _complete.set(response);
             if(callback != null){
                 callback();
             }
         }, function(xhr, status, errorThrown){
             _error.omitted(xhr, status, errorThrown);
         });
     }

}

/**
 * 測定結果の削除確認モーダルを表示する
 * @param {*} elm
 */
window.measurement_delete_confirm = function(elm) {
    var id = $(elm).data('id');
    var sessionSerial = $(elm).data('session_serial');
    _modal.create_with_data(elm, 'confirm-modal', {'id': id, 'session_serial': sessionSerial});
}

/**
 * 測定結果モーダルのsubmit処理を実行する
 * @param {*} elm
 * @param {*} modalIdDataSelector
 * @param {*} callback
 */
window.measurement_modal_submit = function(elm, modalIdDataSelector, callback){
    var modalId = create_id($(elm).data(modalIdDataSelector));
    var formId = modalId + '-form';
    // 送信前にエラーをリセット
    _error.reset()
    // post送信
    _ajax.submit(formId, function (results) {
        // 完了メッセージをセットする
        _complete.set(results);
        // モーダルを閉じる
        _modal.hide(modalId);
        if(callback != null){
            callback();
        }
    }, function(xhr, status, errorThrown){
        // エラーをセットする
        _error.set(modalId, xhr, status, errorThrown, false);
    });
}
